
CheckoutV2.BillInfo = function(checkout, wrap) {
	var billinfo = this;

	this.valid = false;

	this.$wrap = $( wrap );

	this.$inputFields = this.$wrap.find('input, select');

	this.fields = {
		'country'   : this.$wrap.find('.js-billing_country'),
		'firstname' : this.$wrap.find('.js-billing_firstname'),
		'lastname'  : this.$wrap.find('.js-billing_lastname'),
		'address1'  : this.$wrap.find('.js-billing_address1'),
		'address2'  : this.$wrap.find('.js-billing_address2'),
		'city'      : this.$wrap.find('.js-billing_city'),
		'state'     : this.$wrap.find('.js-billing_state'),
		'zip'       : this.$wrap.find('.js-billing_zip'),
		//'phone'     : this.$wrap.find('.js-billing_phone')
	};

	this.stateRequest = false;

	this.suggestStates = {};

    // Array of functions to be fired when the bill info changes
    // fired by the listener for the modal submit button
    this._infoChangedListeners = [];

    this.registerInfoChangedListener = function(fn) {
        billinfo._infoChangedListeners.push(fn);
    };

    this.removeInfoChangedListener = function(fn) {
    	billinfo._infoChangedListeners = billinfo._infoChangedListeners.filter(function(listener) {
			return listener !== fn;
		});
    };

    this.callInfoChangedListeners = function() {
        billinfo._infoChangedListeners.forEach(function(fn) {
            fn();
        });
    };

	this.init = function() {
		billinfo.listen();
		billinfo.buildContent();
		billinfo.displayBillingAddress();
	};

	this.listen = function() {

		billinfo.$inputFields.focus(function() {
			billinfo.removeFieldError($(this));
		});

		billinfo.fields.country.change(function() {
			billinfo.getStates();
		});

		$.each( billinfo.fields, function( fieldName, $field ) {
			$field.blur( function() {
				// If this causes bugs then /shrug.
				// 'validateField(update)' doesn't seem to take a field name, so the 'update' arg was always true.
				// This caused the session data to save on all blurs.
				// Validation seems to still work. That function starts a decent sized call chain.
                // billinfo.validateField( fieldName );
				billinfo.validateField( false );
			} );
		} );
		
		billinfo.changeAddressListeners();
        billinfo.registerInfoChangedListener( function() { billinfo.displayBillingAddress() } );
        billinfo.registerInfoChangedListener( function() { $('#billingAddressModal').modal('hide') } );
		billinfo.registerInfoChangedListener( function() { billinfo.formReset() } );
	};
	
	this.changeAddressListeners = function() {
		$('.js-change-billing-address').on('click', function(){
			$('#billingAddressModal').modal('show');
		});
		
		$('.js-use-billing-address-btn').on('click', function(){
			if (billinfo.validate(true, true)) {
                billinfo.callInfoChangedListeners();
			}
		});
		
		$('#billingAddressModal').on('hide.bs.modal', function(e){
			if ($(document.activeElement).data('dismiss')) { // reset form from data-dismiss not programmatic hide
				billinfo.formReset();
			}
		});
	};

	this.buildContent = function() {
		billinfo.prefillForm();
		billinfo.getStates( billinfo.fields.state.val() || checkout.session.get().billing.state );
		billinfo.validate(false);
	};

	this.stepTo = function() {
		checkout.nextStep( true, 1 );
	};

	this.prefillForm = function() {
		var session = checkout.session.get(),
			billing = session.billing,
			update  = false;
			
		if (!billinfo.hasBillingSessionData(billing)) {
			billing = billinfo.copyShippingSessionData(session.shipping, billing);
			update = true;
		}
		if (!billinfo.hasCompleteBillingSessionData(billing)) {
			billing = billinfo.copyShippingSessionMissingData(session.shipping, billing);
			update = true;
		}

		$.each( billinfo.fields, function( fieldName, $field ) {
			if( ! billing[ fieldName ] ) return;

			if( ! $field.length ) return;

			$field.val(billing[fieldName]);
			
			//billinfo.validateField( validation );
		} );
		
		if (update) {
			billinfo.setSessionData(billing);
		}

		return true;
	};

	this.getStates = function(selectState) {
		var $stateSelect = billinfo.fields.state,
			$countryOption = billinfo.fields.country.find('option:selected'),
			country = $countryOption.val();

		if (billinfo.stateRequest) billinfo.stateRequest.abort();

		$stateSelect
			.show()
			.attr('disabled', 'disabled')
			.html('<option value="">Loading States...</option>')
			.parent().show();

		if (!country) {
			$stateSelect.html('<option value="">Select a Country above</option>');
			billinfo.fieldError($stateSelect, '');
			return;
		}

		billinfo.stateRequest = checkout.remote.call({
			async: false,
			cache: true,
			data: {
				'step': 'billship',
				'action': 'getStates',
				'country': country
			}
		})
		.done(function(response) {
			billinfo.buildStates(response.data, selectState);
			billinfo.fieldError($stateSelect, '');
			billinfo.validateField( "state" );
		})
		.fail(function(request) {

		})
		.always( function() {
			billinfo.stateRequest = false;
		} );
	};

	this.buildStates = function(states, selectState) {
		selectState = selectState || ''; // TODO: implement later if needed... || billinfo.suggestStates;
		var noState = (selectState && states.length > 1) ? '' : ' selected ';

		var $stateSelect = billinfo.fields.state,
			options = [
				'<option '+ noState+ ' value="">Select State/Province/Territory</option>'
			];

		if (!states.length) {
			$stateSelect.html(options).parent().hide();
			return;
		}

		$.each(states, function(i, state) {
			var isSelected = state.state == selectState ? ' selected ' : '';
			options.push(
				'<option ' + isSelected +' value="'+state.state+'">'
					+ state.name
				+ '</option>'
			);
		});

		$stateSelect
			.removeAttr('disabled')
			.html(options);

		if (selectState) {
			$stateSelect.val(selectState);
		} else {
			$stateSelect[0].selectedIndex = 0;
		}
	};

	this.getData = function(data) {
		data = (data !== undefined) ? data : false;
		if (data) {
			return {
				'billing': {
					'firstname': data.firstname || '',
					'lastname': data.lastname || '',
					'address1': data.address1 || '',
					'address2': data.address2 || '',
					'city': data.city || '',
					'country': data.country || '',
					'zip': data.zip || '',
					'state': data.state || '',
					//'phone': data.phone || '',
				}
			};
		} else {
			return {
				'billing': {
					'firstname': billinfo.fields.firstname.val().trim(),
					'lastname': billinfo.fields.lastname.val().trim(),
					'address1': billinfo.fields.address1.val().trim(),
					'address2': billinfo.fields.address2.val().trim(),
					'city': billinfo.fields.city.val().trim(),
					'country': billinfo.fields.country.val(),
					'zip': billinfo.fields.zip.val().trim(),
					'state': billinfo.fields.state.val(),
					//'phone': billinfo.fields.phone.val(),
				}
			};
		}
	};

	this.setSessionData = function(data) {
		if (data) {
			checkout.session.set(billinfo.getData(data));
		} else {
			checkout.session.set(billinfo.getData());
		}
        checkout.session.save();
	};

	this.validateFields = function( onlyField, onSave ) {
        var address = billinfo.getData().billing;

        $.each( billinfo.fields, function( fieldName, $field ) {
            if( ! onlyField || onlyField == fieldName ) {
                billinfo.fieldValid( $field );
            }
        } );

        billinfo.valid = true;
        var results = window.addressValidator.validate( address );
        $.each( results, function( fieldName, errMsg ) {
            if( ! onlyField || onlyField == fieldName ) {
                var $field = billinfo.fields[ fieldName ];
                billinfo.fieldError( $field, errMsg );
                if (onSave) {
                    var fieldTop = billinfo.fields[ fieldName ].parent().position().top;
                    var windowTop = $('#billingAddressModal').scrollTop();
                    if (fieldTop && fieldTop < windowTop) 
                        $('#billingAddressModal').scrollTop( fieldTop );
                }
            }
        } );
	};

    this.validateField = function( fieldName ) {
        return billinfo.validate( fieldName );
    };

	this.validate = function(update, onSave) {

		// destroy all previous errors

		billinfo.valid = true;
		billinfo.removeFieldErrors();

		if (update) {
			billinfo.setSessionData();
		}

		// start new validation
        billinfo.validateFields( false, onSave );

		//if( ! billinfo.valid ) billinfo.stepTo();
		//billinfo.checkMatchingZipCode();
		
		//billinfo.displayShippingAddress();

		return billinfo.valid;
	};

	this.getFeedback = function( $field ) {
		if( ! $field.length ) return $();
		var feedbackSelector = "." + $field.data( "feedback" );
		return billinfo.$wrap.find( feedbackSelector );
	};

	this.fieldError = function($field, errorMsg) {

		billinfo.valid = false;

		billinfo.getFeedback( $field )
			.removeClass( "text-success" )
			.addClass( "text-danger" )
			.html( errorMsg );

	};

	this.fieldValid = function( $field ) {
		billinfo.getFeedback( $field )
			.removeClass( "text-danger" )
			.addClass( "text-success" )
			.html( "<i class='fa fa-check'></i>" );
	};

	this.removeFieldError = function($field) {
		billinfo.getFeedback( $field ).html( "" );
	};

	this.removeFieldErrors = function() {
		billinfo.$inputFields.each( function( i, field ) {
			billinfo.removeFieldError( $( field ) );
		} );
	};

	this.displayBillingAddress = function() {
		var session = checkout.session.get();
		
		if (session.billing && billinfo.hasBillingSessionData(session.billing)) {
			$('.js-billing-display').html(
				Jemplate.process('includes/partials/billingInfo.html', {
					billing_firstname: session.billing.firstname,
					billing_lastname: session.billing.lastname,
					billing_address1: session.billing.address1,
					billing_address2: session.billing.address2,
					billing_city: session.billing.city,
					billing_state: session.billing.state,
					billing_zip: session.billing.zip,
				})
			);
		}
	};
	
	this.hasBillingSessionData = function(billing) {
		var hasData = 0;
		var fields = ['firstname', 'lastname', 'address1', 'address2', 'country', 'city', 'state', 'zip'];
		for (i in fields) {
			if (hasData) {
				break;
			}
			if (billing[ fields[i] ]) {
				hasData = 1;
			}
		}
		//console.log('hasBillingSessionData',hasData);
		return hasData;
	};
	
	this.hasCompleteBillingSessionData = function(billing) {
		var hasCompleteData = 1;
		var fields = ['firstname', 'lastname', 'address1', 'country', 'city', 'state', 'zip']; // 'address2', 'phone'
		for (i in fields) {
			if (hasCompleteData == 0) {
				break;
			}
			if (!billing[ fields[i] ]) {
				hasCompleteData = 0;
			}
		}
		//console.log('hasCompleteBillingSessionData',hasCompleteData);
		return hasCompleteData;
	};
	
	this.copyShippingSessionData = function(shipping, billing) {
		var fields = ['firstname', 'lastname', 'address1', 'address2', 'country', 'city', 'state', 'zip']; // , 'phone'
		for (i in fields) {
			
			if (shipping[ fields[i] ]) {
				billing[ fields[i] ] = shipping[ fields[i] ];
			}
		}
		//console.log('copyShippingSessionData',billing);
		return billing;
	};
	
	this.copyShippingSessionMissingData = function(shipping, billing) {
		var fields = ['firstname', 'lastname', 'address1', 'address2', 'country', 'city', 'state', 'zip']; // , 'phone'
		for (i in fields) {
			
			if (shipping[ fields[i] ] && !billing[ fields[i] ]) {
				billing[ fields[i] ] = shipping[ fields[i] ];
			}
		}
		//console.log('copyShippingSessionMissingData', billing);
		return billing;
	};
	
	this.formReset = function() {
		var session = checkout.session.get(),
			billing = session.billing;
		
		$.each( billinfo.fields, function( fieldName, $field ) {
			if( ! $field.length ) return;
			
			$field.val(billing[fieldName]);
		} );
		billinfo.validate(false);
	}

	this.init();
};
